"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _constants = require("composer-lib/lib/constants");

var _utils = require("composer-lib/lib/utils");

var _immutable = require("immutable");

var DEFAULTS = {
  status: _constants.RequestStatus.UNINITIALIZED,
  // Composition data from API response
  data: new _immutable.Map(),
  forcedReadOnly: false,
  id: null,
  type: _constants.CompositionTypes.BLOG_POST,
  typeString: 'blogPost',
  updated: null
};

var Composition = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Composition, _Record);

  function Composition() {
    (0, _classCallCheck2.default)(this, Composition);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Composition).apply(this, arguments));
  }

  (0, _createClass2.default)(Composition, [{
    key: "mergeFromJS",
    value: function mergeFromJS(data) {
      return this.merge({
        status: _constants.RequestStatus.SUCCEEDED,
        data: new _immutable.Map(data),
        id: +data.id,
        type: data.type,
        typeString: (0, _utils.getCompositionTypeString)(data.type),
        updated: data.updated
      });
    }
  }, {
    key: "isReadOnly",
    value: function isReadOnly() {
      return this.getIn(['data', 'readOnly']) || this.get('forcedReadOnly');
    }
  }]);
  return Composition;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Composition;
module.exports = exports.default;